import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react';

import { cn } from '../../../utils';
import { PopoverTrigger } from '../../Popover';

type FilterChipTriggerProps = Omit<
  ComponentPropsWithoutRef<typeof PopoverTrigger>,
  'asChild'
>;

export const FilterChipTrigger = forwardRef<
  ElementRef<typeof PopoverTrigger>,
  FilterChipTriggerProps
>(({ className, children, ...props }, ref) => {
  return (
    <PopoverTrigger
      ref={ref}
      className={cn(
        'relative flex flex-row bg-secondary rounded-sm border overflow-hidden cursor-pointer',
        className,
      )}
      asChild
      {...props}
    >
      <div>{children}</div>
    </PopoverTrigger>
  );
});

FilterChipTrigger.displayName = 'FilterChipTrigger';
